'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Select = require('material-ui/Select');

var _Select2 = _interopRequireDefault(_Select);

var _MenuItem = require('material-ui/Menu/MenuItem');

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _withStyles = require('material-ui/styles/withStyles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _us = require('../../assets/img/lang/us.png');

var _us2 = _interopRequireDefault(_us);

var _ru = require('../../assets/img/lang/ru.png');

var _ru2 = _interopRequireDefault(_ru);

var _context = require('@prisma-cms/context');

var _context2 = _interopRequireDefault(_context);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = function styles(theme) {
  return {
    select: {
      display: 'flex',
      alignItems: 'center',
      color: '#fff'
    },
    flag: {
      display: 'inline-block',
      height: 20,
      margin: '0 5px 0'
    }
  };
};

var Language = (_temp2 = _class = function (_Component) {
  _inherits(Language, _Component);

  function Language() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Language);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Language.__proto__ || Object.getPrototypeOf(Language)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (event) {
      var setLanguage = _this.context.setLanguage;
      setLanguage(event.target.value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Language, [{
    key: 'render',
    value: function render() {
      var classes = this.props.classes;
      var getLanguage = this.context.getLanguage;
      var lang = getLanguage();
      return _react2.default.createElement(_Select2.default, {
        value: lang,
        onChange: this.handleChange,
        classes: {
          select: classes.select
        }
      }, _react2.default.createElement(_MenuItem2.default, {
        value: 'en'
      }, _react2.default.createElement('img', {
        src: _us2.default,
        className: classes.flag
      }), 'EN'), _react2.default.createElement(_MenuItem2.default, {
        value: 'ru'
      }, _react2.default.createElement('img', {
        src: _ru2.default,
        className: classes.flag
      }), 'RU'));
    }
  }]);

  return Language;
}(_react.Component), _class.contextType = _context2.default, _temp2);
exports.default = (0, _withStyles2.default)(styles)(function (props) {
  return _react2.default.createElement(Language, props);
});
module.exports = exports['default'];